import dateFormat from '@/utils/dateFormat';

const columns = () => ([
  {
    title: 'Sku',
    dataIndex: 'sku',
    key: 'sku',
  },
  {
    title: 'Display name',
    dataIndex: 'displayName',
    key: 'displayName',
  },
  {
    title: 'Added date',
    dataIndex: 'addedAt',
    key: 'addedAt',
    customRender: ({ text }) => dateFormat(text, 'DD-MM-YYYY HH:MM'),
  },
  {
    title: 'Update date',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    customRender: ({ text }) => dateFormat(text, 'DD-MM-YYYY HH:MM'),
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
]);

export default columns;
